(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[603],{

/***/ 2774:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search",
      function () {
        return __webpack_require__(4182);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Search; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./apollo-client.js + 63 modules
var apollo_client = __webpack_require__(9257);
// EXTERNAL MODULE: ./components/Container/Container.js
var Container = __webpack_require__(7158);
// EXTERNAL MODULE: ./components/Header/Header.js
var Header = __webpack_require__(5137);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js + 4 modules
var useLazyQuery = __webpack_require__(5859);
// EXTERNAL MODULE: ./components/Button/Button.js
var Button = __webpack_require__(3664);
// EXTERNAL MODULE: ./components/PostItem/PostItem.js
var PostItem = __webpack_require__(4884);
// EXTERNAL MODULE: ./components/PostList/utils.js
var utils = __webpack_require__(7290);
// EXTERNAL MODULE: ./components/SearchInput/SearchInput.js
var SearchInput = __webpack_require__(4837);
// EXTERNAL MODULE: ./graphql/queries.js
var queries = __webpack_require__(9699);
// EXTERNAL MODULE: ./components/SearchResults/SearchResults.module.sass
var SearchResults_module = __webpack_require__(1339);
var SearchResults_module_default = /*#__PURE__*/__webpack_require__.n(SearchResults_module);
;// CONCATENATED MODULE: ./components/SearchResults/SearchResults.js


















var INITIAL_STATE = function(param) {
    var pageInfo = param.pageInfo, list = param.list;
    return {
        cursor: pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.endCursor,
        hasMore: pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.hasNextPage,
        list: list
    };
};
var reducer = function(state, param) {
    var payload = param.payload, type = param.type;
    if (type === utils/* ACTION.UPDATE_LIST */.om.UPDATE_LIST) {
        var ref, ref1;
        var newPosts = payload.edges.map(function(param) {
            var node = param.node;
            return node;
        });
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({
            cursor: payload === null || payload === void 0 ? void 0 : (ref = payload.pageInfo) === null || ref === void 0 ? void 0 : ref.endCursor,
            hasMore: payload === null || payload === void 0 ? void 0 : (ref1 = payload.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.hasNextPage,
            list: state.list
        }, "list", (0,_to_consumable_array/* default */.Z)(state.list).concat((0,_to_consumable_array/* default */.Z)(newPosts))));
    }
};
var SearchResults = function(param) {
    var pageInfo = param.pageInfo, results = param.results, term = param.term;
    var ref;
    var query = (0,queries/* getSearchQuery */.uP)({
        term: term
    }).query;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(query), 2), fetchMore = ref1[0], loading = ref1[1].loading;
    var ref2 = (0,react.useReducer)(reducer, INITIAL_STATE({
        pageInfo: pageInfo,
        list: results
    })), posts = ref2[0], dispatch = ref2[1];
    var hasResults = results.length > 0;
    var loadMore = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var cursor, hasMore, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    cursor = posts.cursor, hasMore = posts.hasMore;
                    if (!hasMore) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        fetchMore({
                            variables: {
                                after: cursor,
                                count: 12,
                                term: term
                            }
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    dispatch({
                        payload: data === null || data === void 0 ? void 0 : data.posts,
                        type: utils/* ACTION.UPDATE_LIST */.om.UPDATE_LIST
                    });
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        fetchMore,
        posts,
        term
    ]);
    return !hasResults ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SearchResults_module_default()).searchOnly,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "No results found for ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("quote", {
                        children: [
                            "“",
                            term,
                            "”"
                        ]
                    }),
                    ":("
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                children: [
                    "Search results for “",
                    term,
                    "”"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchInput/* default */.Z, {
                defaultValue: term
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: (SearchResults_module_default()).postList,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        (ref = posts.list) === null || ref === void 0 ? void 0 : ref.map(function(post) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                className: (SearchResults_module_default()).postItem,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostItem/* default */.Z, (0,_object_spread/* default */.Z)({}, post))
                            }, post.id);
                        }),
                        (posts === null || posts === void 0 ? void 0 : posts.hasMore) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (SearchResults_module_default()).loadMore,
                            children: loading ? // eslint-disable-next-line @next/next/no-img-element
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                alt: "Loading...",
                                height: 44,
                                src: "/icons/loading.svg",
                                width: 44
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                onClick: loadMore,
                                children: "I want more"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
SearchResults.propTypes = {
    pageInfo: prop_types_default().shape({
        endCursor: (prop_types_default()).string,
        hasNextPage: (prop_types_default()).bool
    }),
    results: (prop_types_default()).array,
    term: (prop_types_default()).string
};
/* harmony default export */ var SearchResults_SearchResults = (SearchResults);

// EXTERNAL MODULE: ./styles/Home.module.sass
var Home_module = __webpack_require__(3200);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
;// CONCATENATED MODULE: ./pages/search.js












function Search(param) {
    var pageInfo = param.pageInfo, results = param.results, term = param.term;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Home_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                    children: [
                        "search for ",
                        term,
                        " | cake-mag.com"
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "section",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults_SearchResults, {
                        pageInfo: pageInfo,
                        results: results,
                        term: term
                    })
                })
            })
        ]
    });
}
Search.getInitialProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var q, ref, ref1, ref2, ref3, query, variables, data;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    q = param.query.q;
                    if (!q) {
                        return [
                            2,
                            {
                                results: []
                            }
                        ];
                    }
                    ref3 = (0,queries/* getSearchQuery */.uP)({
                        term: q
                    }), query = ref3.query, variables = ref3.variables;
                    return [
                        4,
                        apollo_client/* default.query */.Z.query({
                            query: query,
                            variables: variables
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        {
                            pageInfo: data === null || data === void 0 ? void 0 : (ref = data.posts) === null || ref === void 0 ? void 0 : ref.pageInfo,
                            results: data === null || data === void 0 ? void 0 : (ref1 = data.posts) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.edges) === null || ref2 === void 0 ? void 0 : ref2.map(function(param) {
                                var node = param.node;
                                return node;
                            }),
                            term: q
                        }
                    ];
            }
        });
    });
    return function(_) {
        return _ref.apply(this, arguments);
    };
}();
Search.propTypes = {
    pageInfo: prop_types_default().shape({
        endCursor: (prop_types_default()).string,
        hasNextPage: (prop_types_default()).bool
    }),
    results: prop_types_default().arrayOf(prop_types_default().shape({
        excerpt: (prop_types_default()).string,
        featuredImage: prop_types_default().shape({
            node: prop_types_default().shape({
                sourceUrl: (prop_types_default()).string
            })
        }),
        id: (prop_types_default()).string.isRequired,
        slug: (prop_types_default()).string.isRequired,
        title: (prop_types_default()).string.isRequired,
        uri: (prop_types_default()).string.isRequired
    })),
    term: (prop_types_default()).string
};


/***/ }),

/***/ 1339:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"postList":"SearchResults_postList__6b_Mo","loadMore":"SearchResults_loadMore__vPvm2","postResult":"SearchResults_postResult__xtEk0","imageContainer":"SearchResults_imageContainer__vC9JD","contributorsList":"SearchResults_contributorsList__5C4kB","contributor":"SearchResults_contributor__y5wbD","searchOnly":"SearchResults_searchOnly__KTwVL"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [664,675,913,193,774,888,179], function() { return __webpack_exec__(2774); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);